// import { CSVLink } from 'react-csv';
import * as React from 'react';
import { Button } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus } from '../api';
import RequestParameters from '../api/parameters';
const fileDownload = require('js-file-download');

class State {
    csvData: any;
}

interface Props {
    startDate: any;
    endDate: any;
    alarmFilter: any;
    severityFilter: any;
    objectFilter: any;
    detailFilter: any;

}
export default class ExportCSV extends React.Component<Props, State> {
    csvLink = React.createRef();

    componentWillMount() {
        this.setState({
            csvData: []
        });
    }

    buildParams() {
        let params = '';
        if ((this.props.startDate) && (!this.props.endDate)) {
            params += 'timerange=' + Math.floor(this.props.startDate / 1000) + '%20to%20current' + '&';
        } else
        if ((this.props.endDate) && (!this.props.startDate)) {
            params += 'timerange=before ' + Math.floor(this.props.endDate / 1000) + '&';
        } else
        if ((this.props.startDate) && (this.props.endDate)) {
            params += 'timerange=' + Math.floor(this.props.startDate / 1000) + ' to ' + Math.floor(this.props.endDate / 1000) + '&';
        }
        if (this.props.alarmFilter) {
            params += 'alarm=' + this.props.alarmFilter.toUpperCase() + '&';
        }
        if (this.props.severityFilter) {
            params += 'severity=' + this.props.severityFilter + '&';
        }
        if (this.props.objectFilter) {
            params += 'name=' + this.props.objectFilter + '&';
        }
        if (this.props.detailFilter) {
            params += 'detail=' + this.props.detailFilter + '&';
        }
        return params;
    }

    exportLog(oauth: OAuthClientStatus) {
        let filename = '';
        let url = (oauth.secureHost ? 'https' : 'http') + '://default/api/export?'  + this.buildParams();

        filename = 'IQAlarmLog-';
        filename += this.getSysName(oauth);

        const params = new RequestParameters({
            dataType: 'AlarmLog',
            exportFormat: 'tsv',
            filename: filename
        }).queryString();

        if (params.length > 0)
            url += params;

        axios.post(url)
            .then(function (response: AxiosResponse) {
                let stringObject = response.data;
                fileDownload(stringObject, filename);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('Export Alarm Log error: ', error);
            });
    }

    fetchData = () => {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/alarm-log?' + this.buildParams();
        axios.get(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined) {
                    response.data.entries.forEach((entry: any) => {
                        entry.timestamp = __this.format(entry.timestamp);
                    });

                    __this.setState({
                        csvData: response.data.entries
                    },              () => {
                        // @ts-ignore
                        // tslint:disable-next-line:no-unused-expression
                        (__this.csvLink.current) ? __this.csvLink.current.link.click() : null; });

                } else
                    throw response;

            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('export csv error, got: ', error);
            });
    }

    render() {
        // const headers = [
        //     { label: 'Alarm Time', key: 'timestamp' },
        //     { label: 'Event Status', key: 'eventStatus' },
        //     { label: 'Severity', key: 'severity' },
        //     { label: 'Alarm', key: 'alarmName' },
        //     { label: 'Alarm Description', key: 'alarmDesc' },
        //     { label: 'Template', key: 'detail.flowFlt' },
        //     { label: 'Object', key: 'detail.name' },
        //     { label: 'Type', key: 'detail.streamType' },
        //     { label: 'Host', key: 'detail.url' },
        //     { label: 'Media IP', key: 'detail.mediaIp' },
        //     { label: 'Value', key: 'detail.value' },
        //     { label: 'Threshold', key: 'detail.threshold' },
        //     { label: 'Details', key: 'detail.raw' }
        // ];
        return (
            <OAuth.Context>{(oauth: OAuthClientStatus) => (
                <div>
                    <Button
                        className="filterPanel-secondary-btn"
                        icon="file excel outline"
                        content="Export"
                        onClick={(event, data) => this.exportLog(oauth)}
                    />

                {/*    <CSVLink*/}
                {/*        data={this.state.csvData}*/}
                {/*        headers={headers}*/}
                {/*        filename={'AlarmLog_' + this.getSysName(oauth)}*/}
                {/*        className="hidden"*/}
                {/*        separator={'\t'}*/}
                {/*        // enclosingCharacter={''}*/}
                {/*        ref={this.csvLink as any}*/}
                {/*        target="_blank"*/}
                {/*/>*/}
                </div>
            )}</OAuth.Context>
        );
    }
     format(ts: any | number ) {

            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];

            let newDate = new Date();
            let timeInMillis = (ts * 1000) + newDate.getTimezoneOffset();
            newDate.setTime(timeInMillis);
            const mo = (newDate.getUTCMonth());
            const dt = ('0' + newDate.getUTCDate()).slice(-2);
            const hr = ('0' + newDate.getHours()).slice(-2);
            const mi = ('0' + newDate.getUTCMinutes()).slice(-2);
            const se = ('0' + newDate.getUTCSeconds()).slice(-2);

            let date = monthNames[mo] + ' ' + dt + ',  ' + hr + ':' + mi + ':' + se;
            return date;

    }
    getSysName(oauth: OAuthClientStatus) {
        let now = new Date();
        let url = '';
        let sysName = (oauth.sys.name ? oauth.sys.name : 'surveyor-abr');
        // sysName = encodeURIComponent(sysName);

        url += sysName + '-';
        url += (now.getFullYear() + ('0' + (now.getUTCMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2));
        url += '-';
        url += (('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2) + ('0' + now.getSeconds()).slice(-2));
        url += '.tsv';
        return url;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/sys/exportCSV.tsx